/**
 * Reconciliação cross-tab: merge por id, resolver processing órfãos.
 */

import type { QueueItem } from '../queue';

export function mergeQueuesById(
  local: QueueItem[],
  remote: QueueItem[]
): QueueItem[] {
  const map = new Map<string, QueueItem>();
  for (const item of [...remote, ...local]) {
    const existing = map.get(item.id);
    if (!existing || item.createdAt >= existing.createdAt) {
      map.set(item.id, item);
    }
  }
  return Array.from(map.values());
}

export function findOrphanProcessing(
  items: QueueItem[],
  aliveTabIds: Set<string>
): QueueItem[] {
  return items.filter(
    i =>
      i.status === 'processing' &&
      i.processingTabId != null &&
      !aliveTabIds.has(i.processingTabId)
  );
}

export function reconcileProcessingOrphans(
  items: QueueItem[],
  aliveTabIds: Set<string>
): QueueItem[] {
  return items.map(item => {
    if (
      item.status === 'processing' &&
      item.processingTabId &&
      !aliveTabIds.has(item.processingTabId)
    ) {
      return {
        ...item,
        status: 'queued' as const,
        processingTabId: undefined,
        processingStartedAt: undefined,
      };
    }
    return item;
  });
}
